<div #list
  [style.width.px]="width" [style.width]="width !== undefined ? width : '100%'"
  [style.height.px]="height" [style.height]="height !== undefined ? height : '30px'"
  class="overflow-auto card">
  <ng-template ngFor let-item [ngForOf]="dnaInfoCheckBoxListModel.codeList" let-i="index">
    <div class="checkbox-group" [class.selected]="lastClickId === item.DnaDiv" (change)="onChange(item.DnaDiv)">
      <label>
        <input type="checkbox" [(ngModel)]="item.selectedValue[0]" class="checkbox">{{ item.DnaDivName  }}
      </label>
    </div>
  </ng-template>
</div>
